import _ from 'lodash';

export const QueryConf = {
  get: (list, filter, search, filterConf, searchConf) => {
    const { pagination, sort } = list;
    const { value: searchValue } = search;
    const { value: filterValue } = filter;
    const selectedUsers = _.get(filterValue, 'user_id', []);

    return {
      pagination: { ...pagination },
      sort: _.isArray(sort)
        ? sort?.map((item) =>
          _.setWith({}, [...item?.by.split('.')], item.direction, Object)
        )
        : `${sort.by}:${sort.direction}`,
      filters: {
        $or: searchConf?.query.keys.map(({ key, operator }) =>
          _.setWith(
            {},
            _.chunk([...key.split('.'), operator]),
            searchValue,
            Object
          )
        ),
        $and: [
          ...filterConf?.query.keys
            .filter(({ value }) => value !== 'user_id.id')
            .filter(({ key, value }) => {
              const filterVal = _.get(filterValue, value);
              if ((key === 'createdAt' || value.includes('date')) && !filterVal) {
                return false;
              }
              return true;
            })
            .map(({ key, operator, value }) => {
              const newValue = _.get(filterValue, _.head(_.split(value, '.')));

              if (_.isArray(newValue)) {
                return {
                  $or: newValue.map((item) => {
                    return item?.id === null
                      ? { [key]: { $null: true } }
                      : _.setWith(
                        {},
                        _.chunk([...key.split('.'), operator]),
                        _.get(item, _.last(_.split(value, '.'))),
                        Object
                      );
                  }),
                };
              } else {
                return newValue?.id === null
                  ? { [key]: { $null: true } }
                  : _.setWith(
                    {},
                    _.chunk([...key.split('.'), operator]),
                    _.get(filterValue, value),
                    Object
                  );
              }
            }),
          ...(selectedUsers.length > 0
            ? [
              {
                $or: selectedUsers.map((user) => ({
                  $or: [
                    { created_by_user_id: { id: { $eq: user.id } } },
                    { closed_by_user_id: { id: { $eq: user.id } } },
                    { notes: { id_user: { id: { $eq: user.id } } } },
                  ],
                })),
              },
            ]
            : []),
        ],
      },
    };
  },
};